module.exports = __webpack_public_path__ + "static/media/memory-logo@3x.9fe97745.png";